import {
  peekItemDragPayload,
  setItemDragPayload,
  claimItemDragPayload,
  endItemDrag,
} from "../../core/drag/itemDragSource";

/** Configurator paletinden sürüklenen öğenin `payload.kind` değeri. */
export const CONFIGURATOR_ITEM_KIND = "configurator-module";

/**
 * Bu dosya eskiden configurator'e özel bir "bekleyen sürükleme" deposuydu.
 * Aynı problemi room designer da ayrı şekilde çözüyordu; depo artık ortak
 * (`core/drag/itemDragSource`). Buradakiler yalnızca modelin ham verisini
 * çıkaran ince sarmalayıcılar.
 */
export function setConfiguratorPendingDragModel(model: unknown): void {
  setItemDragPayload({ kind: CONFIGURATOR_ITEM_KIND, data: model });
}

/**
 * Önizlemeyi sahiplen. Yük sürükleme bitene kadar okunabilir kalır — drop
 * yüzeyinin `dragover`'da `preventDefault()` çağırabilmesi buna bağlı.
 */
export function takeConfiguratorPendingDragModel(): unknown {
  return claimItemDragPayload()?.data;
}

export function peekConfiguratorPendingDragModel(): unknown {
  return peekItemDragPayload()?.data;
}

export function clearConfiguratorPendingDragModel(): void {
  endItemDrag();
}
